import { type Temporal } from '@js-temporal/polyfill'
import prettyMilliseconds, { type Options } from 'pretty-ms'

export default function formatDuration (duration: Temporal.Duration, options: Options): string {
  return prettyMilliseconds(duration.total('milliseconds'), options)
}
